import { CloseButton, CloseButtonProps } from '@chakra-ui/react';
import React from 'react';

export const CmCloseButton: React.FC<CloseButtonProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <CloseButton {...rest} />;
};
